
export type TableSearcherTypesEnum = number;
export let TableSearcherTypesEnum: any = {};
TableSearcherTypesEnum.ON_TABLE = 0;
TableSearcherTypesEnum.ON_BACKEND = 1;
TableSearcherTypesEnum.EMPTY_TABLE_APPLY_BACKEND = 2;
TableSearcherTypesEnum[TableSearcherTypesEnum.ON_TABLE] = "ON_TABLE";
TableSearcherTypesEnum[TableSearcherTypesEnum.ON_BACKEND] = "ON_BACKEND";
TableSearcherTypesEnum[TableSearcherTypesEnum.EMPTY_TABLE_APPLY_BACKEND] = "EMPTY_TABLE_APPLY_BACKEND";

